var _basicInputStyle$vari;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { fonts } from '../../../theme';
import { zIndex } from '../../../theme/z-index';
import { createOwnUpStyle } from '../../style';
var basicStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  color: colors.PRIMARY,
  background: colors.WHITE,
  ':focus': {
    outline: '0px none'
  }
}));
var basicAdvisorStyle = createOwnUpStyle({
  textAlign: 'start',
  minWidth: '122px',
  minHeight: '36px',
  border: 'none',
  borderRadius: '2px',
  fontSize: '14px',
  lineHeight: '32px',
  letterSpacing: '0.5px',
  whiteSpace: 'nowrap',
  position: 'relative'
});
var basicInputStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, basicStyle), {}, {
  display: 'flex',
  '& > *:first-child': {
    flexGrow: 1
  },
  variants: {
    advisorSide: _objectSpread(_objectSpread({}, basicAdvisorStyle), {}, {
      padding: '0 13px'
    }),
    success: {
      background: colors.SUCCESS_ALT
    },
    warn: {
      background: colors.WARN_ALT
    },
    danger: {
      background: colors.DANGER_ALT
    },
    xsmall: {
      maxWidth: '165px'
    },
    onboarding: _objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
      fontSize: '15px',
      color: colors.PRIMARY,
      backgroundColor: colors.TRANSPARENT,
      position: 'absolute',
      border: 'none',
      marginTop: 28,
      marginLeft: 20,
      paddingTop: 0,
      paddingLeft: 0,
      ':focus': {
        outline: 'none'
      },
      width: '100%',
      maxWidth: '100%',
      textAlign: 'left'
    })
  }
}));
export var OwnUpDropDownInputStyle = createOwnUpStyle(_objectSpread({}, basicInputStyle));
export var OwnUpDropDownItemStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, basicInputStyle), {}, {
  variants: {
    advisorSide: _objectSpread({}, (_basicInputStyle$vari = basicInputStyle.variants) === null || _basicInputStyle$vari === void 0 ? void 0 : _basicInputStyle$vari.advisorSide),
    success: {
      ':hover': {
        background: colors.SUCCESS_ALT
      }
    },
    warn: {
      ':hover': {
        background: colors.WARN_ALT
      }
    },
    danger: {
      ':hover': {
        background: colors.DANGER_ALT
      }
    },
    onboarding: _objectSpread(_objectSpread({}, basicAdvisorStyle), {}, {
      position: 'relative',
      marginTop: 0,
      marginBottom: 0,
      width: '100%',
      paddingLeft: 20,
      ':hover': {
        background: colors.BACKGROUND
      }
    })
  }
}));
export var OwnUpDropDownWrapperStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, basicStyle), {}, {
  width: 'fit-content',
  zIndex: zIndex.DropDown,
  variants: {
    advisorSide: _objectSpread(_objectSpread({}, basicAdvisorStyle), {}, {
      boxShadow: "1px 2px 5px ".concat(colors.GREY),
      padding: '5px 0'
    }),
    success: {},
    warn: {},
    danger: {},
    onboarding: {
      width: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      maxHeight: '40vh'
    }
  }
}));
export var OwnUpDropDownMenuWrapperStyle = createOwnUpStyle({
  position: 'relative',
  variants: {
    onboarding: {
      top: '50px'
    }
  }
});
export var OwnUpDropDownBreakStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, basicStyle), {}, {
  variants: {
    advisorSide: {
      borderBottom: "1px solid ".concat(colors.PRIMARY),
      margin: '0 6px'
    },
    success: {},
    warn: {},
    danger: {},
    onboarding: {}
  }
}));
export var OwnUpDropDownChevronStyle = createOwnUpStyle({
  variants: {
    advisorSide: {},
    success: {},
    warn: {},
    danger: {},
    onboarding: {
      marginTop: 0,
      transform: 'translateX(100%) translate(-32.5px, -12px)'
    }
  }
});